function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
}, { threshold: 0 });
document.querySelectorAll('.reveal').forEach(el => io.observe(el));

/* Rozcestniky receptu a Kucharka nemaji hero, sticky listu ani final-cta.
   Bez teto podminky spadne skript na TypeError pri nacteni i pri kazdem
   odrolovani. Kdyz nektery prvek chybi, sticky logika se proste nespusti. */
const stickyBar = document.getElementById('stickyBar');
const heroEl = document.querySelector('.hero');
const finalEl = document.getElementById('final-cta');
if (stickyBar && heroEl && finalEl) {
  const updateSticky = () => {
    const heroBottom = heroEl.getBoundingClientRect().bottom;
    const finalTop = finalEl.getBoundingClientRect().top;
    const vh = window.innerHeight;
    if (heroBottom < 0 && finalTop > vh * 0.3) stickyBar.classList.add('visible');
    else stickyBar.classList.remove('visible');
  };
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  updateSticky();
}

/* ==========================================================================
   ZIVE CENY na vstupnich strankach znacek (2026-09-17)
   Pripojit na KONEC assetu landing-page.js (Edit code v adminu).

   Ceny karet (.viv-prod-price) a hero produktu (.hero-product-price) jsou
   v tele stranky zapsane natvrdo. Tenhle kod si pri zobrazeni stranky dotahne
   aktualni prodejni cenu z /products/<handle>.js a text prepise, kdyz se lisi.
   Handle bere z odkazu karty, u hero karty z tlacitka uvnitr karty.
   Zaokrouhluje na cele koruny matematicky, stejne jako detail produktu.
   Pri chybe nebo vypadku nechava cenu z tela stranky.
   Vysledek drzi 10 minut v sessionStorage, aby prochazeni webu neposilalo
   stejne dotazy porad dokola.
   Kontrolni znacka pro denni rutinu: LP-LIVE-PRICES-V1
   ========================================================================== */
(function () {
  var root = document.querySelector('.landing-page-content');
  if (!root || !window.fetch) return;
  var els = root.querySelectorAll('.viv-prod-price, .hero-product-price');
  if (!els.length) return;

  function handleOf(el) {
    var a = el.closest('a[href*="/products/"]');
    if (!a) {
      var card = el.closest('.hero-product-card');
      a = card && card.querySelector('a[href*="/products/"]');
    }
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function fmt(cents) {
    var kc = Math.round(cents / 100);
    return String(kc).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč';
  }

  var byHandle = {};
  Array.prototype.forEach.call(els, function (el) {
    var h = handleOf(el);
    if (h) (byHandle[h] = byHandle[h] || []).push(el);
  });

  function apply(h, cents) {
    var text = fmt(cents);
    byHandle[h].forEach(function (el) {
      if (el.textContent.replace(/\s/g, '') !== text.replace(/\s/g, '')) el.textContent = text;
      el.setAttribute('data-live-price', '1');
    });
  }

  Object.keys(byHandle).forEach(function (h) {
    var key = 'lpPrice:' + h, cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.t < 600000) { apply(h, cached.p); return; }
    fetch('/products/' + h + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        if (typeof p.price !== 'number') return;
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: p.price })); } catch (e) {}
        apply(h, p.price);
      })
      .catch(function () {});
  });
})();
